var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-item-header',{staticClass:"pc-note__outline-header",attrs:{"name":_vm.name}},[_vm._v("笔记大纲")])}
var staticRenderFns = []

export { render, staticRenderFns }